// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// 路由
import router from './router'
//图片的懒加载
import VueLazyload from 'vue-lazyload'
//seo的管理插件
import MetaInfo from 'vue-meta-info'
import store from './store/store';// 状态管理
import Message from './components/common/message';

Vue.use(VueLazyload)
Vue.use(MetaInfo)
Vue.use(Message);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    setTimeout(() => {
      document.dispatchEvent(new Event('render-event'))
    }, 1000)
  }
})



// WEBPACK FOOTER //
// ./src/main.js